import { h } from "@stencil/core";
import { TableCellProps } from "../table-cell";

export const renderFavToggle = ({
    schemaItem,
    item,
    columnKey,
}: TableCellProps) => (
    <td class={schemaItem.className} data-testid={columnKey}>
        <ux-iws-async-toggle-button
            sync-id={`ux-iws-${item.number}`}
            toggle-url={item[columnKey].toggleUrl}
            key={item[columnKey].toggleUrl}
            on={item[columnKey].active}
        >
            <span slot="on" style={{ color: "#b3d11e" }}>
                <ux-icon name="fav-filled"></ux-icon>
            </span>
            <ux-icon slot="off" name="fav"></ux-icon>
        </ux-iws-async-toggle-button>
    </td>
);
